document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.featured-collections').forEach(function (section) {
    const buttons = section.querySelectorAll('.featured-collections__btn');
    const carousels = section.querySelectorAll('.featured-collections__carousel');
    const viewAllLinks = section.querySelectorAll('.featured-collections__view-all [data-block-id]');
    if (!buttons.length || !carousels.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const targetId = btn.dataset.target;
        if (!targetId) return;

        buttons.forEach(function (b) {
          const isActive = b === btn;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        carousels.forEach(function (c) {
          c.classList.toggle('hidden', c.dataset.blockId !== targetId);
        });

        // Keep the "view all" link pointing at the collection now on screen.
        viewAllLinks.forEach(function (link) {
          link.classList.toggle('hidden', link.dataset.blockId !== targetId);
        });
      });
    });
  });
});
